// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const TABLE_VIEW_STEP_SHAPES = [
  {
    stepType: PipelineStepType.TABLE_VIEW,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      viewName: {
        kind: 'string',
        required: true
      },
      displayOptions: {
        kind: 'shape',
        required: false,
        fields: {
          columnIconDecorations: {
            kind: 'array',
            required: true,
            elementSpec: {
              kind: 'shape',
              required: true,
              fields: {
                targetColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: true,
                  validationOptions: null
                },
                booleanColumn: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: true,
                  validationOptions: null
                },
                icon: {
                  kind: 'string',
                  required: true
                },
                tooltip: {
                  kind: 'string',
                  required: false
                },
                headerTooltip: {
                  kind: 'string',
                  required: false
                }
              }
            }
          },
          hiddenColumns: {
            kind: 'array',
            required: false,
            elementSpec: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Input dataset',
              allowMissingColumn: true,
              validationOptions: null
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
